<template>
    <basic-layout>
        <v-main>
            <v-form @submit.prevent="handlePasswordReset">
                <v-container>
                    <v-layout wrap>
                        <v-flex xs12 xl10 offset-xl2>
                            <h1>Complete Registration</h1>
                            <p>Please use the form below to complete your registration.</p>
                            <p class="subheading warning--text">All fields are required</p>
                        </v-flex>
                        <v-flex xs8 offset-xs2>
                            <v-text-field
                                data-testid="reset-password-email-input"
                                class="reset-password-email-input"
                                v-model.trim="userInfo.email"
                                filled
                                required
                                label="Email"
                                type="Email"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <v-text-field
                                data-testid="reset-password-input"
                                class="reset-password-input"
                                v-model.trim="userInfo.password"
                                filled
                                required
                                :rules="passwordRules"
                                label="Password"
                                type="password"
                                hint="Password must contain at least 8 characters, including one number and one special character"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <v-text-field
                                data-testid="reset-password-confirm-input"
                                class="reset-password-confirm-input"
                                v-model.trim="userInfo.passwordConfirm"
                                filled
                                required
                                :rules="passwordsMatch"
                                label="Confirm Password"
                                type="password"
                            />
                        </v-flex>
                        <v-flex xs12 xl10 offset-xl2>
                            <v-btn
                                data-testid="reset-password-btn"
                                class="reset-password-btn ml-0"
                                color="primary"
                                type="submit"
                            >
                                Reset Password
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-main>
    </basic-layout>
</template>

<script>
import BasicLayout from "@/layouts/BasicLayout.vue";
import { passwordRules } from "@/helpers/form-rules";

export default {
  data() {
    return {
      userInfo: {
        email: null,
        password: null,
        passwordConfirm: null
      },
      passwordRules: passwordRules
    };
  },

  components: {
    BasicLayout
  },

  methods: {
    handlePasswordReset() {
      const payload = {
        email: this.userInfo.email,
        password: this.userInfo.password,
        password_confirmation: this.userInfo.passwordConfirm,
        token: this.$route.params.token
      };

      this.$store.dispatch("resetPassword", payload)
        .then(() => {
          this.$router.push({ name: "login" }).catch(() => {});
        });
    }
  },

  computed: {
    passwordsMatch() {
      const rules = [];
      if (this.userInfo.password) {
        let rule = v => (!!v && v) === this.userInfo.password || "Passwords must match";
        rules.push(rule);
      };
      return rules;
    }
  }
};
</script>
